import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauDupliquerAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Dupliquer';
		this.type = BordereauActionType.DUPLIQUER;

		this.isShown = (bordereau) => bordereau.typePes !== '02';
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		result: Promise.resolve(bordereau),
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauDuplicationModal: {
				visible: true,
				typeAction: BordereauActionType.DUPLIQUER,
			},
		},
	});

	executeAction = (
		result: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.ADD,
		result: Promise.resolve(result),
	});
}

export default BordereauDupliquerAction;
